<template>
	<div class="box">
		<!-- 顶部导航 -->
		<div class="top">
			<div class="top_s">
				<span class="top_txt">排序</span>
				<image class="top_img" src="../../static/paixv.png" mode=""></image>
			</div>
			<div class="top_s">
				<span class="top_txt">筛选</span>
				<image class="top_img" src="../../static/shaixuan.png" mode=""></image>
			</div>
			<div class="top_s">
				<span class="top_txt">搜索</span>
				<image class="top_img" src="../../static/sousuo.png" mode=""></image>
			</div>
		</div>

		<!-- 体检套餐选项卡 -->
		<div class="Package" @click="package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nantouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">乐享健康体检套餐(男)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限男性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥1219.00</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nantouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">基础套餐(男)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限男性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥2829</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nvtouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">基础套餐(女)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限女性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥3564</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nantouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">全面体检套餐(男)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限男性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥6787</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nvtouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">全面体检套餐(女)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限女性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥7522</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nantouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">深度体检套餐(男)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限男性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥19034.62</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>
		<div class="Package">
			<div class="Package_left">
				<img class="Package_left_img" src="../../static/nvtouxiang.png" alt="">
			</div>
			<div class="Package_right">
				<span class="Package_txt">深度体检套餐(女)</span>
				<div class="Package_t">
					<span class="Package_txt1">健康体检</span>
					<span class="Package_txt1">仅限女性</span>
					<span class="Package_txt1">手机查报告</span>
				</div>
				<div class="Package_right_txt">
					<div class="Package_txt2">￥20109.62</div>
					<div class="Package_right_txt3">
						<div class="Package_txt3">空军军医大学第二附属医院</div>
						<div class="Package_txt3">(唐都医院)</div>
					</div>

				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			package() {
				uni.navigateTo({
					url: '/pages/PackageDetails/PackageDetails'
				})
			}
		}
	}
</script>

<style>
	.top {
		width: 100%;
		height: 70rpx;
		background-color: #fd8b4d;
		display: flex;
		justify-content: space-around;
	}

	.top_s {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.top_txt {
		font-size: 14px;
		margin-right: 8px;
		color: #fff;
	}

	.top_img {
		width: 20px;
		height: 20px;
	}

	.Package {
		width: 100%;
		height: 104px;
		display: flex;
		align-items: center;
	}

	.Package_left_img {
		width: 200rpx;
		height: 200rpx;
	}

	.Package_right {
		width: 290px;
		height: 104px;
	}

	.Package_txt {
		font-size: 14px;
		margin-bottom: 10px;
	}

	.Package_t {
		margin-bottom: 10px;
	}

	.Package_txt1 {
		font-size: 12px;
		margin-right: 10px;
		border-radius: 2px 2px 2px 2px;
		color: #ff4f00;
		background-color: #f4cfb8;
	}

	.Package_right_txt {
		display: flex;
		justify-content: space-between;
	}

	.Package_txt2 {
		color: #ee842f;
		font-size: 14px;
	}

	.Package_right_txt3 {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.Package_txt3 {
		font-size: 12px;
		color: #ccc;
	}
</style>
